import React, { createContext, useState, useContext, ReactNode } from "react";
import axios, { AxiosResponse } from 'axios'

interface User {
    success: boolean;
    token: string;
    data: {
        id: string;
        nama: string;
        email: string;
    };
}

interface AuthContextType {
    user: User | null;
    loginUser: (user: User) => void;
    logoutUser: () => void;
    getAccessToken: () => void;
}

interface ResponseAxios {
    message: string;
    status: boolean;
    token: any;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [user, setUser] = useState<User | null>(() => {
        const savedUser = localStorage.getItem("user");
        return savedUser ? JSON.parse(savedUser) : null;
    });

    const loginUser = (user: User) => {
        setUser(user);
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem('cabang', '1');
    };

    const logoutUser = () => {
        setUser(null);
        localStorage.removeItem("user");
    };

    // Fungsi untuk mendapatkan refresh token dari localStorage
    function getAccessToken() {
        const user = localStorage.getItem("user");
        return user;
    }

    // Fungsi untuk mengecek apakah token masih valid
    function isTokenExpired(token: any) {
        const payload = JSON.parse(atob(token.split('.')[1])); // Decode JWT token
        const expiry = payload.exp * 1000; // Convert to milliseconds
        return expiry < Date.now();
    }

    // Fungsi untuk refresh token
    async function refreshAccessToken() {
        const refreshToken = getAccessToken();
        if (!refreshToken) {
            console.error('No refresh token available');
            return null;
        }

        try {
            const response: AxiosResponse<ResponseAxios> = await axios.post('/auth/refresh-token', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${refreshToken}`,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.data;

            if (data.status) {
                // Token baru berhasil didapatkan
                const newAccessToken = data.token;
                localStorage.setItem('user', newAccessToken); // Simpan token baru ke localStorage
                return newAccessToken;
            } else {
                // Refresh token tidak valid, perlu login ulang
                console.error('Refresh token expired or invalid');
                return null;
            }
        } catch (error) {
            console.error('Error refreshing token:', error);
            return null;
        }
    }

    return (
        <AuthContext.Provider value={{ user, loginUser, logoutUser, getAccessToken }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
